import React from "react";

const navItems = [
  { id: "experience", label: "Work" },
  { id: "skills", label: "Skills" },
  { id: "about", label: "About" },
  { id: "contact", label: "Contact" },
];

export default function Navigation() {
  return (
    <header className="sticky top-0 z-50 border-b border-ink bg-paper">
      <nav className="mx-auto flex h-14 max-w-page items-center justify-between px-5 md:px-10">
        <a href="#hero" className="font-serif text-lg font-semibold tracking-tight">
          G<span className="text-vermilion">/</span>F
        </a>
        <ul className="flex gap-4 sm:gap-8">
          {navItems.map((item) => (
            <li key={item.id}>
              <a
                href={`#${item.id}`}
                className="label transition-colors hover:text-vermilion"
              >
                {item.label}
              </a>
            </li>
          ))}
        </ul>
      </nav>
    </header>
  );
}
